import React from 'react';
import { Divider, Flex, Menu, MenuProps } from 'antd';
import { Link } from 'react-router-dom';
import { CloseOutlined } from '@ant-design/icons';

interface NavbarMenuProps {
  url: string;
  logo: string;
  items: MenuProps['items'];
  keys: string;
  isMobileView?: boolean;
  onClose?: () => void;
  className?: string;
}

const NavbarMenu: React.FC<NavbarMenuProps> = ({
  url,
  logo,
  items,
  keys,
  isMobileView = false,
  onClose,
  className,
}) => {
  return (
    <div className={className}>
      <Flex gap="large" align="center" vertical>
        {isMobileView ? (
          <Flex style={{ width: '100%' }} justify="space-between">
            <Link to={url} className="logo">
              <img src={logo} alt="Logo" />
            </Link>
            <CloseOutlined
              className="close-drawer"
              onClick={onClose}
            />
          </Flex>
        ) : (
          <Link to={url} className="logo">
            <img src={logo} alt="Logo" />
          </Link>
        )}
        <Divider style={{ margin: '-10px' }} />
        <Flex gap="middle" className="option-btn-group" vertical>
          <Menu
            theme="light"
            style={{ width: '100%' }}
            selectedKeys={[keys]}
            items={items}
            className="custom-menu"
          />
        </Flex>
      </Flex>
    </div>
  );
};

export default NavbarMenu;
